import { toSearchText } from "@/core/helpers/routeSearch";
import { createFileRoute } from "@tanstack/react-router";

type ConsignmentStockInRequestCreateSearch = {
	produk?: string;
	toko?: string;
};

export const Route = createFileRoute(
	"/vendor/consignment-stock-in-request/create",
)({
	validateSearch: (
		search: Record<string, unknown>,
	): ConsignmentStockInRequestCreateSearch => ({
		produk: toSearchText(search.produk),
		toko: toSearchText(search.toko),
	}),
	component: () => null,
});
